import { FC, useEffect, useState } from "react";
import Modal from "react-modal";
import close from "assets/images/close.svg";
import Button from "components/particles/primary-button";
import { Container, StyledReactModal } from "./style";
import { dispatch } from "store";
import placeHolder from "assets/images/placeholder.jpg";

import { setModalClosed } from "store/user-slice";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { CategoryLinkedIngredientDTO } from "utils/helpers/models/category-linked-ingredient.dto";
import useCategories from "containers/categories/useHook";

interface CategoriesModelProps {
  id: number;
  name?: string;
  onRefresh?: () => void;
}

const SelectIngredientModel: FC<CategoriesModelProps> = ({
  id,
  name,
  onRefresh,
}) => {
  const { selectIngredientModalIsOpen } = useSelector(
    (state: any) => state.user
  );
  const [searchData, setSearchdata] = useState<any[]>([]);
  const [selectedIngredients, setSelectedIngredients] = useState<number[]>([]);
  const { postCategoryLinkedIngredient, availableIngredientsForLink } =
    useCategories();
  const { setValue, getValues, handleSubmit } =
    useForm<CategoryLinkedIngredientDTO>({
      defaultValues: {
        categoryId: 0,
        ingredientIds: [],
      },
    });

  function closeModal() {
    dispatch(setModalClosed("Select Ingredient"));
  }

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      fontSize: "2rem",
      width: "68.5rem",
    },
  };

  const [searchQuery, setSearchQuery] = useState({
    name: "",
  });

  const search = () => {
    availableIngredientsForLink(searchQuery.name, setSearchdata);
  };

  useEffect(() => {
    if (id) {
      availableIngredientsForLink("", setSearchdata);
    }
  }, [id]);

  const handleChange = (field: any, value: any) => {
    setSearchQuery({
      ...searchQuery,
      [field]: value,
    });
  };

  const onSubmit = async (data: CategoryLinkedIngredientDTO) => {
    try {
      await postCategoryLinkedIngredient(data);
      // Refresh the parent data to update ingredient count
      if (onRefresh) {
        onRefresh();
      }
    } catch (error) {
      console.error("Error linking ingredients:", error);
    }
  };

  useEffect(() => {
    setValue("ingredientIds", selectedIngredients);
    setValue("categoryId", id);
  }, [selectedIngredients]);

  const handleCheckboxChange = (ingredientId: number) => {
    setSelectedIngredients((prevSelected) =>
      prevSelected.includes(ingredientId)
        ? prevSelected.filter((id) => id !== ingredientId)
        : [...prevSelected, ingredientId]
    );
  };

  const resetFields = () => {
    setSearchQuery({ name: "" });
    setSelectedIngredients([]);
    setSearchdata([]);
      availableIngredientsForLink("", setSearchdata);
  };

  return (
    <StyledReactModal
      isOpen={selectIngredientModalIsOpen}
      onRequestClose={closeModal}
  
      contentLabel="Example Modal"
    >
      <Container>
        <div className="close-button" onClick={closeModal}>
          <img src={close} style={{ cursor: "pointer" }} alt="img" />
        </div>
        <div className="popup-title">
          <h1>
            {name
              ? `Link Ingredients to ${name}`
              : "Select Category Ingredients"}
          </h1>
        </div>
      </Container>
      <div className="search-container">
        <div className="input-fields">
          <input
            type="text"
            placeholder="Search By Name"
            value={searchQuery.name}
            onChange={(e) => handleChange("name", e.target.value)}
          />
        </div>
        <Button title="Search" width="16rem" fill="true" onclick={search} />
        <Button
          title="Reset"
          width="16rem"
          fill="true"
          backgroundcolor="var(--reset-button)"
          onclick={resetFields}
        />
      </div>
      <Container onSubmit={handleSubmit(onSubmit)}>
        <div className="categories-model-ingredient-container p-custom-scrollbar-8 custom-scrollbar">
          <div className="categories-container">
            {searchData.length > 0 ? (
              searchData.map((item, index) => (
                <div className="ingredient-data" key={index}>
                  <input
                    type="checkbox"
                    checked={selectedIngredients.includes(item.id)}
                    onChange={() => handleCheckboxChange(item.id)}
                  />
                  <img 
                    src={
                      item?.image && !item?.image.includes(`${process.env.REACT_APP_BASE_URL}images/placeholder`)
                        ? item?.image
                        : placeHolder
                    } 
                    alt="img" 
                  />
                  <h5>{item.name}</h5>
                </div>
              ))
            ) : (
              <p> No data found</p>
            )}
          </div>
        </div>
        <div className="add-button">
          {selectedIngredients.length === 0 ? (
            <div style={{ pointerEvents: "none", opacity: 0.5 }}>
              <Button
                title="Add"
                width="51.8rem"
                backgroundcolor="var(--primary)"
                fill="true"
              />
            </div>
          ) : (
            <Button
              title="Add"
              width="51.8rem"
              backgroundcolor="var(--primary)"
              fill="true"
            />
          )}
        </div>
      </Container>
    </StyledReactModal>
  );
};

export default SelectIngredientModel;
